class HttpApi {
    #apiEndpointBase = null;

    initialize() {
        this.#apiEndpointBase = `http${process.env.NODE_ENV === 'development' ? '' : 's'}://${window.location.host}`;

        if (!this.#apiEndpointBase.endsWith('/')) {
            this.#apiEndpointBase += '/';
        }

        const apiVersion = process.env.GATSBY_API_VERSION || 'v1';
        this.#apiEndpointBase += `api/${apiVersion}/`;
    }

    #constructApiUrl(path) {
        if (typeof path !== 'string' || path.length === 0) {
            throw new Error('HttpApi client is not initialized.');
        }

        return this.#apiEndpointBase + (path.startsWith('/') ? path.substring(1) : path);
    }

    post(path, body, opts) {
        return fetch(this.#constructApiUrl(path), {
            method: 'post',
            redirect: 'follow',     // Follows redirects internally. Navigation is still handled manually.
            headers: {'Content-Type': 'application/json'},
            body: body,
            ...opts
        }).then((res) => {
            if (!res.ok) {
                const error = new Error(`HTTP error! status: ${res.status}`);
                error.response = res;
                error.status = res.status;
                throw error;
            }
            return res;
        });
    }
}

const httpApi = new HttpApi();

export default httpApi;